import { mapGetters, mapActions } from "vuex";
import socket from "@/services/sockets/socket";
import { CurrenciesService, FavoriteService } from "@/services";
import * as types from "@/store/types";
import $thousandMask from "@/mixins/thousandMask";
import $enDigits from "@/mixins/enDigits";

export default {
  name: "prices-list-page",
  components: {},
  mixins: [$thousandMask, $enDigits],
  props: [],
  data() {
    return {
      tableSortBy: "",
      showAnimation: false,
      // diagramPrice: require("@/assets/images/Prices/chart.png"),
      selectedTab: 1,
      walletTableLoader: true,
      // searchIcon: require("@/assets/images/Prices/search_icon.svg"),
      // favoriteIcon: require("@/assets/images/Prices/crypto_favorite.svg"),
      // favoriteIconFull: require("@/assets/images/Prices/crypto_favorite_full.svg"),
      search: "",
      favoriteList: [],
      selectedCategory: this.$t("pricesPage.categoriesMenu[0]"),
      checkbox: true,
      currencyRank: 1
    };
  },
  computed: {
    ...mapGetters({
      topCurrenciesData: types.currencies.getters.GET_TOP_CURRENCIES
    }),
    filterResult() {
      if (this.selectedTab === 1) {
        return this.newTableData.filter(elem => {
          return (
            elem.name_locale.includes(
              this.$enDigits(this.search.toLowerCase())
            ) ||
            elem.name
              .replace(/ +/gu, "")
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(/ +/gu, "")) ||
            elem.iso
              .replace(/ +/gu, "")
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(/ +/gu, ""))
          );
        });
      } else {
        if (this.favoriteList) {
          return this.newTableData.filter(elem => {
            if (this.favoriteList.find(fave => fave.id === elem.id)) {
              return (
                elem.name_locale.includes(this.search.toLowerCase()) ||
                elem.name.toLowerCase().includes(this.search.toLowerCase()) ||
                elem.iso.toLowerCase().includes(this.search.toLowerCase())
              );
            }
          });
        }
      }
    },
    newTableData() {
      let dataArr = [...this.topCurrenciesData];
      switch (this.selectedCategory) {
        case this.$t("pricesPage.categoriesMenu[0]"):
          dataArr.sort((a, b) => parseFloat(a.rank) - parseFloat(b.rank));
          break;
        case this.$t("pricesPage.categoriesMenu[1]"):
          dataArr.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
          break;
        case this.$t("pricesPage.categoriesMenu[2]"):
          dataArr.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
          break;
      }
      return dataArr;
    }
  },
  async mounted() {
    await this.handleCryptoPrices();
    await this.initWebSocket();
    await this.getFave();
  },
  methods: {
    ...mapActions({
      topCurrenciesDataAction: types.currencies.actions.SET_TOP_CURRENCIES
    }),
    changeTableSortBy(val) {
      this.tableSortBy = val;
    },
    removeThousand(str) {
      return str.toString().replace(/,/gi, "");
    },
    changeTableData() {
      this.changeTableSortBy();
      return this.newTableData;
    },
    async getFave() {
      FavoriteService.getFavoritesCurrencies()
        .then(res => {
          this.favoriteList = res.data.data;
          // if (this.favoriteList.length !== 0) {
          //   this.selectedTab = 2;
          // }
        })
        .then(() => {
          this.walletTableLoader = false;
        });
    },
    toggleFav(item) {
      if (this.favoriteList.find(el => el.id === item.id)) {
        FavoriteService.removeFavoritesCurrencies(item.id)
          .then(res => {
            this.$toast.success(res.data.message);
          })
          .then(() => {
            this.getFave();
          });
      } else {
        FavoriteService.addFavoritesCurrencies(item.id)
          .then(res => {
            this.$toast.success(res.data.message);
          })
          .then(() => {
            this.getFave();
          });
      }
    },
    async handleCryptoPrices() {
      CurrenciesService.getCryptoPrice().then(response => {
        this.handleWebSocketData(response.data.data);
      });
    },
    async handleWebSocketData(socketData) {
      this.showAnimation = false;
      this.currencies = await socketData;
      if (this.topCurrenciesData.length !== 0) {
        await this.currencies.forEach(elem => {
          elem.market_cap = Number(this.removeThousand(elem.market_cap));
          this.topCurrenciesData.find(function(data) {
            if (data.iso === elem.iso) {
              if (data.price > elem.price) {
                elem.price_status = "fall";
              } else if (data.price < elem.price) {
                elem.price_status = "raise";
              } else {
                elem.price_status = "static";
              }
            }
          });
        });
      } else {
        await this.currencies.forEach(elem => {
          elem.market_cap = Number(this.removeThousand(elem.market_cap));
          elem.price_status = "static";
        });
      }
      await this.topCurrenciesDataAction(this.currencies);
      this.showAnimation = true;
    },
    async initWebSocket() {
      socket.ECHO.channel("prices").listen(".price.updated", async event => {
        await this.handleWebSocketData(event.data);
      });
    }
  },
  beforeDestroy() {
    socket.ECHO.leaveChannel("prices");
  }
};
